import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from '@emotion/styled';
import { I18nextProvider } from 'react-i18next';
import { routes } from './Routes';
import i18n from './i18n';
import { AuthProvider } from '../contexts/AuthContext';
import { ApolloClientProvider } from '../contexts/ApolloClientContext';
import { AmplitudeProvider } from '../contexts/AmplitudeContext';
import { SentryUser } from '../components/SentryUser';
import { Loading } from '../components/common/Loading';
import { useLanguageSync } from '../hooks/useLanguageSync';

const App = () => {
  useLanguageSync();
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <ApolloClientProvider>
          <SentryUser />
          <AmplitudeProvider>
            <AppContainer>
              <Suspense fallback={<Loading />}>
                <Routes>
                  {routes.map((route) => (
                    <Route key={route.path} path={route.path} element={<route.component />} />
                  ))}
                </Routes>
              </Suspense>
            </AppContainer>
          </AmplitudeProvider>
        </ApolloClientProvider>
      </AuthProvider>
    </I18nextProvider>
  );
};

const AppContainer = styled.div`
  background: transparent;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export default App;
